"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledcomponents = require('styled-components');

var n = _styledcomponents.keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n        transform: scale(.7);\n    }\n    100% {\n        transform: scale(1);\n    }\n"]))),
    i = exports.b = _styledcomponents.keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"]))),
    r = exports.c = _styledcomponents.keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    0% {\n        transform: scale(1);\n    }\n    100% {\n        transform: scale(.7);\n    }\n"]))),
    s = exports.d = _styledcomponents.keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n"]))),
    e = exports.e = _styledcomponents.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    animation-duration: 0.4s;\n"])));

exports.a = n;
exports.b = i;
exports.c = r;
exports.d = s;
exports.e = e;